import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button, 
    // Icon 
} from "antd";
// import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    // getValidateStatus,
    submitForm
} from "utilities/form";
import "styles/form.css";
import { PRE_APPROVAL_ATTACHMENT_FORM, POST_APPROVAL_ATTACHMENT_FORM } from "constants/form-fields";
const FormItem = Form.Item;
class BusinessAttachmentsDetailsForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, () => null);

    saveAttachments = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            this.props.values && this.props.values.get("id") ? this.props.updateAttachmentDetails({...values, business_program: this.props.businessProgramId}) : this.props.saveAttachments({...values, business_program: this.props.businessProgramId});
        });
    }

    render() {
        return (
            <div className={"p-10"}>
                <Form
                    className={cx("form", "br-3")}
                    layout={"horizontal"}
                >
                    <h2>{"Pre Approval Documents"}</h2>
                    <div 
                        className={"form-row"}
                    >
                        {PRE_APPROVAL_ATTACHMENT_FORM.map((field, fieldName) => {
                            return (
                                <div key={fieldName}>
                                    {
                                        this.fieldGenerator(
                                            fieldName,
                                            field,
                                            this.getErrorOnField(fieldName)
                                        )()
                                    }
                                    {this.props.values && this.props.values.get(fieldName) ? <a href={this.props.values.get(fieldName)}>{this.props.values.get(fieldName).split("/").reverse()[0]}</a> : null }
                                </div>
                            );
                        }).toList()}
                    </div>
                    <h2>{"Post Approval Documents"}</h2>
                    <div
                        className={"form-row"}
                    >
                        {POST_APPROVAL_ATTACHMENT_FORM.map((field, fieldName) => {
                            return (
                                <div key={fieldName}>
                                    {
                                        this.fieldGenerator(
                                            fieldName,
                                            field,
                                            this.getErrorOnField(fieldName)
                                        )()
                                    }
                                    {this.props.values && this.props.values.get(fieldName) ? <a href={this.props.values.get(fieldName)}>{this.props.values.get(fieldName).split("/").reverse()[0]}</a> : null }
                                </div>
                            );
                        }).toList()}
                    </div>
                    <div className="d-flex justify-content-flex-end">
                        <FormItem className={cx("mr-5")}>
                            <Button key="save" type="primary" icon={"plus"} onClick={this.saveAttachments}>{this.props.values && this.props.values.get("id") ? "Update" : "Save"}</Button>
                        </FormItem>
                    </div>
                    
                </Form>
            </div>
        );
    }
}

BusinessAttachmentsDetailsForm.propTypes = {
    form: PropTypes.object,
    saveAttachments: PropTypes.func,
    businessProgramId: PropTypes.number,
    values: PropTypes.object,
    updateAttachmentDetails: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
        values
            .toSeq()
            .toMap()
            .map((value) => {
                return Form.createFormField({
                    value
                });
            })
            .toJS();
    }
})(BusinessAttachmentsDetailsForm);